/**
 * One entry point for "the user handed us a spreadsheet". Picks the reader by
 * what the bytes actually are, not by the file name — banks habitually label
 * things `.xls` that are not.
 */
import { isXls, readXls } from './xls'
import { isZip, readXlsx } from './xlsx'

const looksLikeHtml = (bytes) => {
  let head = ''
  for (let i = 0; i < Math.min(bytes.length, 512); i++) head += String.fromCharCode(bytes[i])
  return /<\s*(html|table|!doctype)/i.test(head)
}

/**
 * @param {ArrayBuffer|Uint8Array} input
 * @returns {Promise<{ sheets: { name: string, rows: (string|number|null)[][] }[] }>}
 */
export async function readWorkbook(input) {
  const bytes = input instanceof Uint8Array ? input : new Uint8Array(input)
  if (!bytes.length) throw Object.assign(new Error('That file is empty'), { code: 'sheet.empty' })
  if (isZip(bytes)) return readXlsx(bytes)
  if (isXls(bytes)) return readXls(bytes)
  if (looksLikeHtml(bytes)) {
    throw Object.assign(new Error('That is a web page saved as .xls — re-export it as a real Excel file'), { code: 'sheet.web-page' })
  }
  throw Object.assign(new Error('Not an Excel file — export the statement as .xlsx or .xls'), { code: 'sheet.not-excel' })
}
